<!-- 雇员清单 -->
<template>
  <div>
    <a-row :gutter="24">
      <div id="start" class="title_">
        <div class="cutleft_">添加雇员清单</div>
        <div class="cutoff_"></div>
      </div>
      <div class="btn-top-box">
        <div></div>
        <div class="policy_none">
          <a @click="$tools.downloadFile(fileCodeContent.emp_url)" class="down_excel">点击下载被保险人批量导入excel文件模版</a>
          <a-upload name="file" :multiple="true" action="/api/file/parseInsuredExcel" @change="handleFileChange">
            <a-button type="primary" :style="disabledAll ? 'color:#ccc;border: 1px solid #ddd;' : ''" :disabled="disabledAll" icon="upload">
              批量上传
            </a-button>
          </a-upload>
        </div>
      </div>
      <div class="table-box">
        <a-table
          :pagination="false"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          :columns="columns"
          :data-source="data"
          :scroll="{ x: 1600 }"
        >
          <span slot="num" slot-scope="text, records, index">
            {{Number(index) + 1 }}
          </span>
          <span slot="idType" slot-scope="idType">{{ filterIdType(idType) }}</span>
          <span slot="occulevel" slot-scope="occulevel">{{ handocculevel(occulevel) }}</span>
          <span slot="gender" slot-scope="gender">{{ gender == 'M' || gender == '男' ? '男' : '女' }}</span>
        </a-table>
      </div>
      <div class="flex justify-cneter btn-box">
        <a-button icon="edit" @click="editPreson" :style="disabledAll ? 'color:#ccc;border: 1px solid #ddd;' : ''" :disabled="disabledAll">
          修改被保人
        </a-button>
        <a-button icon="delete" @click="delTele" :style="disabledAll ? 'color:#ccc;border: 1px solid #ddd;' : ''" :disabled="disabledAll">
          批量删除
        </a-button>
        <a-button icon="copy" @click="visibleStick = true" :style="disabledAll ? 'color:#ccc;border: 1px solid #ddd;' : ''" :disabled="disabledAll">
          粘贴名单
        </a-button>
        <a-button icon="plus" @click="addGuyuan" :style="disabledAll ? 'color:#ccc;border: 1px solid #ddd;' : ''" :disabled="disabledAll">
          新增人员
        </a-button>
        <div class="baoxian-num">被保险人共：{{ data.length }}人</div>
      </div>
    </a-row>
    <!-- 粘贴名单 -->
    <a-modal class="myModal_" width="1021px" title="粘贴名单数据" forceRender v-model="visibleStick" @ok="handleStick" okText="确定" cancelText="关闭">
      <div>
        <span :style="{ color: 'red' }">*</span>
        <div style="display: inline-block">字段与字段直接用空格隔开，时间格式支持2018-01-01或2018/01/01。<font color="red"> （切记每一项文本之间不能有空格，多个请用换行符（回车）分割。）</font></div>
        <div style="margin-bottom: 8px; padding-left: 6px">
          例如：CC 身份证 110101199003074207 1990-03-07 女 1050401 工程师 1类
        </div>
      </div>
      <textarea v-model="stickData" name="stickArea" id="stickArea" cols="30" rows="12" :style="{ width: '100%' }"></textarea>
    </a-modal>
    <!-- 新增雇员信息 -->
    <a-modal width="1021px" title="新增雇员信息" forceRender v-model="addShow" @ok="handleSubmitNew" okText="确定" cancelText="关闭">
      <div class="list">
        <a-form layout="horizontal" class="horizontal_item_" :form="form" @submit="handleSubmitNew">
          <a-row>
            <a-col :span="10">
              <a-form-item :label-col="{ span: 8 }" label="姓名">
                <a-input
                  v-decorator="[
                    'addInsured.name',
                    {
                      rules: [{ required: true, message: '请输入姓名' }],
                      initialValue: addInsured.name
                    }
                  ]"
                  placeholder="请输入姓名"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10" class="mg_left_20">
              <a-form-item :label-col="{ span: 8 }" label="证件类型">
                <a-select
                  placeholder="请选择"
                  v-model="addInsured.idType"
                  v-decorator="[
                    'addInsured.idType',
                    {
                      rules: [{ required: true, message: '请选择证件类型' }],
                      initialValue: addInsured.idType ? addInsured.idType : undefined
                    }
                  ]"
                >
                  <a-select-option v-for="item in IdTypeOptions" :key="item.value" :value="item.value">{{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item :label-col="{ span: 8 }" label="证件号码">
                <a-input
                  @blur="addInsured.idType == '1' ? idNumberChange($event) : ''"
                  v-decorator="[
                    'addInsured.idNumber',
                    {
                      rules: [{ required: true, message: '请输入证件号码' }],
                      initialValue: addInsured.idNumber
                    }
                  ]"
                  placeholder="请输入证件号码"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10" class="mg_left_20">
              <a-form-item :label-col="{ span: 8 }" label="出生日期">
                <a-date-picker
                  :disabled="addInsured.idType == '1'"
                  v-decorator="[
                    'addInsured.birthDate',
                    {
                      rules: [{ required: true, message: '请选择出生日期' }],
                      initialValue: addInsured.birthDate
                    }
                  ]"
                  placeholder="请选择出生日期"
                  :disabledDate="disabledDate"
                  :default-picker-value="minAge"
                />
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item :label-col="{ span: 8 }" label="性别">
                <a-select
                  :disabled="addInsured.idType == '1'"
                  placeholder="请选择"
                  v-decorator="[
                    'addInsured.gender',
                    {
                      rules: [{ required: true, message: '请选择性别' }],
                      initialValue: addInsured.gender ? addInsured.gender : undefined
                    }
                  ]"
                >
                  <a-select-option v-for="item in sexOptions" :key="item.value" :value="item.value">{{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10" class="mg_left_20">
              <a-form-item :label-col="{ span: 8 }" label="职业类别">
                <a-select
                  placeholder="请选择"
                  @change="occulevelChange"
                  v-decorator="[
                    'addInsured.occulevel',
                    {
                      rules: [{ required: true, message: '请选择职业类别' }],
                      initialValue: addInsured.occulevel ? addInsured.occulevel : undefined
                    }
                  ]"
                >
                  <a-select-option v-for="item in occupationOptionsLevel" :key="item.value" :value="item.value"> {{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="20">
              <a-form-item :label-col="{ span: 4 }" label="职业名称">
                <a-cascader
                  ref="occupation"
                  @change="(value, label) => occupationChange(value, label)"
                  :show-search="{ filter }"
                  :fieldNames="{
                    label: 'text',
                    value: 'value',
                    children: 'children'
                  }"
                  v-decorator="[
                    'addInsured.occupation',
                    {
                      rules: [{ required: true, message: '请选择职业名称' }],
                      initialValue: addInsured.occupation
                    }
                  ]"
                  :options="occurOptions"
                  placeholder="请选择职业名称"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
    <a-modal v-model="filterShow" title="不合格投保人" :closable="false">
      <template slot="footer">
        <a-button key="submit" type="primary" @click="hideModal">
          确认
        </a-button>
      </template>
      <p v-for="(item, index) in filterArray" :key="index" v-html="item"></p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
let DATA = require('../data').default;
import { salInsuredListMixins } from '@/mixins/salInsuredListMixins.js';
import moment from 'moment';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  mixins: [salInsuredListMixins],
  data() {
    //这里存放数据
    return {
      filterShow: false,
      filterArray: [], //被过滤的数组
      addBol: true,
      selectedRows: [], //选中的人员
      selectedRowKeys: [], //选中的人员
      visibleStick: false, //粘贴名单
      stickData: '', //粘贴的内容
      addShow: false, //新增雇员信息的弹窗
      addInsured: {
        name: '', //姓名
        idType: '', //证件类别
        idNumber: '', //证件号码
        birthDate: null, //出生日期
        gender: '', //性别
        occupation: [],
        occulevel: '', //职业类别
        occupationCode: '', //职业类别代码
        occupationName: '' //职业类别名称
      },
      sexOptions: DATA.sexOptions,
      IdTypeOptions: [
        {
          name: '身份证',
          value: '1'
        },
        {
          name: '中国护照',
          value: '2'
        },
        {
          name: '其他',
          value: '99'
        }
      ],
      occupationOptionsLevel: DATA.occupationOptionsLevel, //职业分类
      minAge: moment().subtract(16, 'years'),
      form: this.$form.createForm(this, { name: 'time_related_controls' }),
      riskInfos: {
        disabilityByAccident: 100000,
        allowanceByAccident: 0
      }
    };
  },
  //监听属性 类似于data概念
  //监控data中的数据变化
  watch: {
    filterArray(val) {
      this.filterShow = val.length > 0;
    }
  },
  //方法集合
  methods: {
    moment,
    hideModal() {
      this.filterShow = false;
      this.filterArray = [];
    },
    reactdata() {
      this.addInsured = {
        name: '', //姓名
        idType: '', //证件类别
        idNumber: '', //证件号码
        birthDate: null, //出生日期
        gender: '', //性别
        occupation: [],
        occulevel: '', //职业类别
        occupationCode: '', //职业类别代码
        occupationName: '' //职业类别名称
      };
    },
    filter(inputValue, path) {
      //联动选择
      return path.some(option => option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    handocculevel(data) {
      let str = data.toString();
      if (str.indexOf('类') > -1) {
        return str;
      } else {
        return str + '类';
      }
    },
    //职业类别
    occulevelChange(value) {
      console.log(value);
      this.addInsured.occulevel = value;
      this.form.setFieldsValue({
        addInsured: {
          occupationName: '',
          occupation: []
        }
      });
    },
    //职业名称
    occupationChange(value, label) {
      this.addInsured.occulevel ? this.addInsured.occulevel : label[2].occulevel;
      this.form.setFieldsValue({
        addInsured: {
          occulevel: label ? label[2].occulevel : undefined
        }
      });
    },
    //限制生日的选项
    disabledDate(current) {
      const minAge = moment().subtract(16, 'years');
      const maxAge = moment().subtract(70, 'years');
      return current && (current > minAge || current < maxAge);
    },
    //确定雇员信息
    handleSubmitNew(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        let index = this.data.length;
        if (!err) {
          if (/\d/.test(values.addInsured.name)) {
            this.$message.error(`被保人“${values.addInsured.name}”证件号为“${values.addInsured.idNumber}”的名称中不能包含数字`, 3);
            return;
          }
          if (values.addInsured.idType == '1') {
            if (!this.$regTest.checkIdCard(values.addInsured.idNumber)) {
              this.$message.error(`被保人证件号码不合法!`, 3);
              return;
            }
          }
          let sign = this.data.filter(item => item.idNumber === values.addInsured.idNumber);
          if (!this.addBol) {
            //修改
            var signIndex = this.addInsured.index;
            let obj = {
              ...values.addInsured,
              index: signIndex,
              beneficialType: 1,
              occulevel: values.addInsured.occulevel,
              birthDate: moment(values.addInsured.birthDate).format('YYYY-MM-DD'),
              occupationName: this.filterName(values.addInsured.occupation),
              occupationCode: values.addInsured.occupation[2],
              eduitIndex: this.selectedRowKeys[0]
            };

            let age = this.$tools.jsGetAge(obj.birthDate, this.effectiveDate);
            if (age < 16 || age > 70) {
              this.$message.error('投保人年龄仅限于16-70周岁，请修改后再试！');
              return;
            }
            this.$emit('EduitSelect', obj);
            this.addShow = false;
          } else {
            //添加
            if (sign.length > 0) {
              this.$message.error('被保人证件号码重复');
              return;
            }
            let obj = {
              ...values.addInsured,
              beneficialType: 1,
              index: index,
              occulevel: values.addInsured.occulevel,
              birthDate: moment(values.addInsured.birthDate).format('YYYY-MM-DD'),
              occupationName: this.filterName(values.addInsured.occupation),
              occupationCode: values.addInsured.occupation[2]
            };
            let age = this.$tools.jsGetAge(obj.birthDate, this.effectiveDate);
            if (age < 16 || age > 70) {
              this.$message.error('投保人年龄仅限于16-70周岁，请修改后再试！');
              return;
            }
            this.$emit('addSelect', obj);
            this.addShow = false;
          }
        }
      });
    },
    //新增雇员信息
    addGuyuan() {
      this.addBol = true;
      this.addShow = true;
      this.reactdata();
      this.form.resetFields();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    editPreson() {
      this.reactdata();
      //修改被保人
      this.addBol = false;
      if (this.selectedRowKeys.length !== 1) {
        this.$message.error('请选择要修改的被保人');
        return;
      }
      // debugger
      this.addShow = true;
      // console.log(this.selectedRowKeys);
      var eduitobj = this.$lodash.cloneDeep(this.data[this.selectedRowKeys[0]]);
      if (!eduitobj.occupation) {
        eduitobj.occupation = [eduitobj.occupationCode.substring(0, 3), eduitobj.occupationCode.substring(0, 5), eduitobj.occupationCode];
      }
      eduitobj.occulevel = eduitobj.occulevel.toString().indexOf('类') > -1 ? eduitobj.occulevel.slice(0, 1) : eduitobj.occulevel;
      this.addInsured = eduitobj;
      this.form.setFieldsValue({
        addInsured: {
          ...eduitobj
        }
      });
    },
    //批量删除
    delTele() {
      if (!this.selectedRowKeys.length) {
        this.$message.error('请选择要删除的被保人');
        return;
      }
      // 删除被保人
      let cusData = this.$lodash.cloneDeep(this.data);
      let filter = cusData.filter((item, index) => {
        return this.selectedRowKeys.indexOf(index) < 0;
      });
      cusData = filter;
      this.$emit('delSelect', cusData);
      this.selectedRowKeys = [];
    },
    //粘贴
    handleStick() {
      if (!this.stickData) {
        this.$message.error('您还没有任何输入！');
        return;
      }
      var arrs = [];
      var allArr = this.stickData
        .replace(/\n/g, '#')
        .split('#')
        .filter(e => e != '');
      allArr.forEach(e => {
        let arr = e.trim().split(/\s+/g);
        let obj = {};
        if (/\d/.test(arr[0])) {
          this.filterArray.push(`被保人“${arr[0]}”证件号为“${arr[2]}”的名称中<font color="red">不能包含数字</font>，请检查后重新上传！`);
          return;
        }
        if (arr[1] == '身份证') {
          if (!this.$regTest.checkIdCard(arr[2])) {
            this.filterArray.push(`被保人“${arr[0]}”证件号为“${arr[2]}”的身份证有误，请检查后重新上传！`);
            return;
          }
        }
        let age = this.$tools.jsGetAge(arr[3], this.effectiveDate);
        if (age < 16 || age > 70) {
          this.filterArray.push(`被保人“${arr[0]}”证件号为“${arr[2]}”的年龄为<font color="red">${age}</font>，不在16-70周岁之间，请检查后重新上传！`);
          return;
        }
        arr[6] = this.filterName([arr[5].substring(0, 2), arr[5].substring(0, 4), arr[5]]);
        this.columns.forEach((e, i) => {
          obj[e.dataIndex] = arr[i];
          obj['occulevel'] = arr[arr.length - 1];
        });
        obj.index = this.data.length;
        obj.beneficialType = 1;
        obj.occulevel = parseInt(obj.occulevel);
        arrs.push(obj);
      });
      this.$emit('addSelect', arrs);
      this.stickData = '';
      this.visibleStick = false;
    },
    //批量上传
    handleFileChange(info) {
      // 文件导入
      if (info.file.status === 'done') {
        console.log(info);
        let length = this.data.length;
        let newArr = [];
        info.file.response.content.forEach((item, index) => {
          if (/\d/.test(item.insName)) {
            this.filterArray.push(`被保人“${item.insName}”证件号为“${item.insIdNumber}”的名称中<font color="red">不能包含数字</font>，请检查后重新上传！`);
            return;
          }
          if (item.occulevel == '0') {
            this.filterArray.push(`被保人“${item.insName}”证件号为“${item.insIdNumber}”的行业code为<font color="red">${item.occupationCode}</font>不存在，请检查后重新上传！`);
            return;
          }

          let age = this.$tools.jsGetAge(item.insBirthday, this.effectiveDate);
          if (age < 16 || age > 70) {
            this.filterArray.push(`被保人“${item.insName}”证件号为“${item.insIdNumber}”的年龄为<font color="red">${age}</font>，不在16-70周岁之间，请检查后重新上传！`);
            return;
          }
          let obj = {
            index: index + length,
            name: item.insName, //姓名
            idType: this.substitutionType(item.insIdType), //证件类别
            idNumber: item.insIdNumber, //证件号码
            birthDate: item.insBirthday, //出生日期
            gender: this.filterSex(item.insGender), //性别
            beneficialType: 1,
            occupationCode: item.occupationCode, //职业代码
            occupationName: this.filterName([item.occupationCode.substring(0, 2), item.occupationCode.substring(0, 4), item.occupationCode]), //职业名称
            occulevel: item.occulevel, //职业类别

            //暂时不用的参数开始
            occupation: [item.occupationCode.substring(0, 2), item.occupationCode.substring(0, 4), item.occupationCode], //职业类别
            mobile: item.phone,
            height: 11, //与主被保人关系 同上

            uniqueid: '', //被保人保额
            premium: '', //被保人保费
            workUnit: item.insWorkUnit, //证件生效日
            termOfValidity: [moment(item.insWorkUnit), moment(item.insInvalidate)], //证件有效期
            invalidate: item.insInvalidate, //证件失效日
            type: 'C' // 固定值
            //暂时不用的参数结束
          };
          if (obj.idType == '1') {
            if (!this.$regTest.checkIdCard(obj.idNumber)) {
              this.filterArray.push(`被保人“${item.insName}”证件号为“${item.insIdNumber}”的身份证有误，请检查后重新上传！`);
              return;
            }
          }
          let currentTime = new Date(); //自定义时间
          var customTime = item.insInvalidate;
          customTime = new Date(Date.parse(customTime));
          if (currentTime.getTime() - customTime.getTime() > 0) {
            this.filterArray.push(`被保人“${item.insName}”证件号为“${item.insIdNumber}”的证件有效期不合法，请检查后重新上传！`);
            return;
          }
          newArr.push(obj);
        });
        this.$emit('addSelect', newArr);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 文件导入失败，请重试！`);
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.btn-box {
  margin: 20px 0;
}

.btn-box button {
  margin: 0 20px;
  border: 1px solid #fe8f2d;
  color: #fe8f2d;
}

.btn-top-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-top-box button {
  margin: 0 0 10px 20px;
  border: 1px solid #fe8f2d;
  color: #fff;
}

.baoxian-num {
  font-size: 16px;
  font-weight: bold;
}
</style>
